import type { UserRole, OrgPlan } from '@/api/types'

type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'neutral'

interface StatusBadgeProps {
  label: string
  variant?: BadgeVariant
}

const variantClasses: Record<BadgeVariant, string> = {
  success: 'bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300',
  warning: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/50 dark:text-yellow-300',
  error: 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-300',
  info: 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-300',
  neutral: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
}

export function StatusBadge({ label, variant = 'neutral' }: StatusBadgeProps) {
  return (
    <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${variantClasses[variant]}`}>
      {label}
    </span>
  )
}

export function RoleBadge({ role }: { role: UserRole }) {
  const map: Record<UserRole, BadgeVariant> = {
    owner: 'error',
    admin: 'warning',
    member: 'neutral',
  }
  return <StatusBadge label={role} variant={map[role]} />
}

export function PlanBadge({ plan }: { plan: OrgPlan }) {
  const map: Record<OrgPlan, BadgeVariant> = {
    free: 'neutral',
    starter: 'info',
    pro: 'success',
    enterprise: 'warning',
  }
  return <StatusBadge label={plan} variant={map[plan]} />
}
